// ABOUTME: Host page — lists games the signed-in user owns and manages.
// ABOUTME: Responsive card grid with Create Game CTA and empty state.
import { useState, useEffect } from 'react'
import { useAuth } from '@clerk/react'
import { Link } from 'react-router'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { GameCard } from '../components/GameCard'
import { GameCardSkeleton } from '../components/GameCardSkeleton'
import { Pagination } from '../components/Pagination'
import { gameActionsControllerGetUserOwnedGames, type GameDto } from '../api/generated'

export function HostPage() {
  const { getToken } = useAuth()
  const [games, setGames] = useState<GameDto[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [loadError, setLoadError] = useState<string | false>(false)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      const token = await getToken()
      try {
        const res = await gameActionsControllerGetUserOwnedGames(
          { page, limit: 50 },
          { headers: { Authorization: `Bearer ${token}` } },
        )
        if (res.status === 200) {
          setGames(res.data.items as unknown as GameDto[])
          setTotalPages(res.data.totalPages)
        }
      } catch {
        setLoadError('Could not load your games. Please refresh the page.')
      } finally {
        setIsLoading(false)
      }
    }
    load()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <Box pt={4}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1">Host</Typography>
        <Button variant="contained" component={Link} to="/games/new">Create Game</Button>
      </Stack>
      <Snackbar open={!!loadError} onClose={() => setLoadError(false)}>
        <Alert severity="error" onClose={() => setLoadError(false)}>
          {loadError}
        </Alert>
      </Snackbar>
      {isLoading ? (
        <Grid container spacing={3}>
          {[0, 1, 2].map((i) => (
            <Grid key={i} size={{ xs: 12, sm: 6, md: 4 }}>
              <GameCardSkeleton />
            </Grid>
          ))}
        </Grid>
      ) : games.length === 0 ? (
        <Box textAlign="center" py={8}>
          <Typography color="text.secondary" mb={2}>No games yet.</Typography>
          <Button variant="contained" component={Link} to="/games/new">Create Game</Button>
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            {games.map((game) => (
              <Grid key={game.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <GameCard game={game} href={`/games/${game.id}/manage`} />
              </Grid>
            ))}
          </Grid>
          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </Box>
  )
}
